<script setup lang="ts">
import { useTemplateRef } from 'vue'
import { usePageContext } from '@/composables/usePageContext'
import { useScreen } from '@/composables/useScreen'
import { useStaticAsset } from '@/composables/useStaticAsset'
import ContactForm, { type ContactFormExpose } from '@/ui-kit/help/ContactForm.vue'

interface PageContext {
  title: string
  cover_image: string
  content: string
  links: {
    oferta: string
  }
}

const ctx = usePageContext<PageContext>()
const { isMobile } = useScreen()
const asset = useStaticAsset()
const contactForm = useTemplateRef<ContactFormExpose>('contactForm')
</script>

<template>
  <main v-cloak id="studyinjoy-article-view" class="contents studyinjoy-article-view">
    <header class="studyinjoy-article-view__header">
      <img :height="isMobile ? 40 : 64" :src="asset('img/logo.svg')" />

      <v-button href="/users/login?student_login=true" :mode="isMobile ? 'primary text' : 'primary large'">
        Войти на сайт
      </v-button>
    </header>

    <img class="studyinjoy-article-view__cover" :src="ctx.cover_image" />

    <section class="studyinjoy-article-view__content">
      <h1 class="studyinjoy-article-view__title">
        {{ ctx.title }}
      </h1>

      <article v-html="ctx.content"></article>
    </section>

    <footer class="studyinjoy-article-view__footer">
      <div class="studyinjoy-article-view__footer-content">
        <div class="d-flex flex-column align-start">
          <img height="48" :src="asset('img/logo.svg')" />

          <template v-if="!isMobile">
            <span class="flex-spacer my-1"></span>

            <p class="text-body-bold">ИП Мещеряков О.Ю.</p>

            <p class="text-body mt-2">ОГРНИП 321169000014352</p>
            <p class="text-body mt-1">ИНН 165703420351</p>
          </template>
        </div>

        <ul class="studyinjoy-article-view__footer-list">
          <li class="studyinjoy-article-view__footer-list-title">Навигация</li>

          <li>
            <v-link href="/public/">Главная страница</v-link>
          </li>
          <li class="mt-2">
            <v-link href="/seminars/base_seminar_info">Базовый семинар</v-link>
          </li>
          <li class="mt-2">
            <v-link href="/parent/smartbook_info">Умный Учебник</v-link>
          </li>
          <li class="mt-2">
            <v-link href="/public/study_in_joy/articles">Статьи</v-link>
          </li>
        </ul>

        <ul class="studyinjoy-article-view__footer-list">
          <li class="studyinjoy-article-view__footer-list-title">Общая информация</li>

          <li>
            <v-link :href="ctx.links.oferta" target="_blank"> Пользовательское соглашение </v-link>
          </li>
          <li class="mt-2">
            <v-link href="/help/center" target="_blank"> Справочный центр </v-link>
          </li>
        </ul>

        <ul class="studyinjoy-article-view__footer-list">
          <li class="studyinjoy-article-view__footer-list-title">Контакты</li>

          <li>
            <v-link @click="() => contactForm?.$open()"> Написать в поддержку </v-link>
          </li>

          <div class="d-flex mt-4">
            <v-link href="https://vk.com/ilemirgovorit" target="_blank" class="mr-2">
              <v-icon size="40">social-vk</v-icon>
            </v-link>
            <v-link href="https://t.me/ileconf2024" target="_blank" class="mr-2">
              <v-icon size="40">social-tg</v-icon>
            </v-link>
            <v-link href="https://www.youtube.com/@mirgovorit" target="_blank">
              <v-icon size="40">social-yt</v-icon>
            </v-link>
          </div>
        </ul>
      </div>

      <div v-if="isMobile" class="d-flex flex-column mt-5">
        <p class="text-body-bold">ИП Мещеряков О.Ю.</p>

        <p class="text-body mt-2">ОГРНИП 321169000014352</p>
        <p class="text-body mt-1">ИНН 165703420351</p>
      </div>

      <div class="flex-adaptive justify-end mt-5 gray-text">
        <span> &copy; Мещерякова В.Н. 2020 </span>
        <span class="mx-3 mt-1"></span>
        <span> &copy; Кирякин И.В. 2020 </span>
      </div>
    </footer>

    <ContactForm ref="contactForm" />
  </main>
</template>

<style lang="scss">
@use '@/styles/pages/public/studyinjoy-article-view.scss' as *;
@import url('https://fonts.googleapis.com/css2?family=Caveat:wght@700&display=swap');
</style>
